import { runtime } from '../runtime/Runtime';
import { AspectContext } from './AspectContext';
export class AttachedContext extends AspectContext {
    at_raw;
    constructor(at_raw) {
        super(at_raw.aspect);
        this.at_raw = at_raw;
    }
    get entity() {
        return this.at_raw;
    }
    get at() {
        return this.at_raw;
    }
    get aspect() {
        return this.at.aspect;
    }
    get actor() {
        if (this.at instanceof runtime.class.AttachedContent)
            return this.at;
        return this.aspect.actor;
    }
    get rootCondition() {
        return this.at.trait.condition;
    }
    get runtime() {
        return runtime;
    }
}
